import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { loadableUserDetailsAtom } from '@/atoms/queries/user';
import { initializeQualtrics } from '../qualtrics';

export const useQualtrics = () => {
  const userDetails = useAtomValue(loadableUserDetailsAtom);
  useEffect(() => {
    if (userDetails.state === 'hasData') {
      const { user } = userDetails.data.data;
      initializeQualtrics(user.hudl_user_id);
    }
  }, [userDetails.state]);
};
